module.exports = __webpack_public_path__ + "img/1J7.e20d9396.png";